GrilleTarifairesController.$inject = [
	'$scope',
	'$state',
	'$stateParams',
	'$translate',
	'ModalService',
	'PaginationService',
	'GrilleTarifairesService',
	'notification',
	'$uibModal',
	'MassiaRightsService'
];

export default function GrilleTarifairesController(
	$scope,
	$state,
	$stateParams,
	$translate,
	ModalService,
	PaginationService,
	GrilleTarifairesService,
	notification,
	$uibModal,
	MassiaRightsService
) {
	const vm = this;

	let previousTableState;

	vm.loading = false;
	vm.params = $stateParams;
	vm.state = $state;
	vm.$translate = $translate;
	vm.$uibModal = $uibModal;
	vm.grilleTarifaires = [];
	vm.MassiaRightsService = MassiaRightsService;

	vm.slideWidth = '500px';
	vm.slideMargin = {
		'margin-right': '0px',
		'transition-duration': '0.5s',
		'transition-animation': 'margin-right',
		height: '100%'
	};
	vm.itemsByPageOptions = [100, 200, 500];
	vm.itemsByPage = vm.itemsByPageOptions[0];

	vm.loadGrilleTarifaires = loadGrilleTarifaires;
	vm.print = print;
	vm.selectGrilleTarifaire = selectGrilleTarifaire;

	async function init() {}

	init();

	async function loadGrilleTarifaires(tableState) {
		startLoading();

		if (tableState) {
			previousTableState = tableState;
		}

		const filters = PaginationService.getFilters(previousTableState);
		const sorts = PaginationService.getSorts(previousTableState);
		const pagination = PaginationService.getPagination(previousTableState);

		vm.grilleTarifaires = [];

		try {
			const data = await GrilleTarifairesService.getGrilleTarifaires(filters, sorts, pagination);

			vm.grilleTarifaires = data.items;

			if (previousTableState) {
				PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
			}
		} catch (ex) {
			notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	function selectGrilleTarifaire(grilleTarifaire) {
		if (grilleTarifaire && grilleTarifaire.id) {
			showDetail(grilleTarifaire.id);
		}
	}

	function showDetail(id) {
		openGrille(id);
	}

	function openGrille(idGrille) {
		const selectedGrille = vm.grilleTarifaires.find((x) => x.id == idGrille);

		if (!selectedGrille) return;

		const { idChantier, idClient, idTypeClient, idSociete, siteCommercialData } = selectedGrille;
		const { idSite = null, idSociete: idSocieteSite = null } = siteCommercialData || {};
		let source = null;
		let domaine = null;
		const base = {
			idSiteCommercial: idSite,
			idSociete: idSocieteSite
		};

		if (idChantier) {
			source = { id: idChantier, ...base };
			domaine = 'chantier';
		} else if (idClient) {
			source = { id: idClient, ...base };
			domaine = 'client';
		} else if (idTypeClient) {
			source = { id: idTypeClient, ...base };
			domaine = 'typeClient';
		} else if (idSite) {
			source = { id: idSite, idSociete: idSocieteSite };
			domaine = 'siteCommercial';
		} else if (idSociete) {
			source = { id: idSociete };
			domaine = 'societe';
		} else {
			return;
		}

		vm.$uibModal.open({
			template:
				'<grilles resolve="$ctrl.resolve" source="$ctrl.source" domaine="$ctrl.domaine" modal-instance="$ctrl.uibModalInstance"></grilles>',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					const $ctrl = this;
					$ctrl.source = source;
					$ctrl.domaine = domaine;
					$ctrl.idGrille = idGrille;
					$ctrl.uibModalInstance = $uibModalInstance;
					$ctrl.resolve = {
						fromExportGrille: true,
						idGrille: idGrille
					};
				}
			],
			controllerAs: '$ctrl',
			size: 'xxl'
		}).result;
	}

	async function print() {
		const modalInstance = ModalService.confirm({
			modalTitle: vm.$translate.instant('GRILLES.PRINTCHECKED.TITLE'),
			modalMsg: vm.$translate.instant('GRILLES.PRINTCHECKED.MESSAGE'),
			headerClass: 'modal-warning'
		});
		modalInstance.result.then(async function () {
			const fileName = Date.now();

			const filters = PaginationService.getFilters(previousTableState);
			const sorts = PaginationService.getSorts(previousTableState);
			const pagination = PaginationService.getPagination(previousTableState);

			const resultat = await GrilleTarifairesService.print(filters, sorts, pagination);

			const data = resultat.data;
			let headers = resultat.headers;

			headers = headers();

			const contentType = headers['content-type'];

			const fileExtention = '.xlsx';
			const linkElement = document.createElement('a');
			try {
				const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
				const url = window.URL.createObjectURL(blob);
				linkElement.setAttribute('href', url);
				linkElement.setAttribute('download', fileName + fileExtention);

				const clickEvent = new MouseEvent('click', {
					view: window,
					bubbles: true,
					cancelable: false
				});
				linkElement.dispatchEvent(clickEvent);
			} catch (ex) {
				console.log('🚀 ~ ex:', ex);
			}
		});
	}

	function startLoading() {
		vm.loading = true;
	}

	function stopLoading() {
		vm.loading = false;
	}
}
